import { createAction } from '@reduxjs/toolkit';
const SET_PAGE_PROPERTIES = 'SET_PAGE_PROPERTIES';
const SET_CURRENT_SKU = 'SET_CURRENT_SKU';
const GET_PDP_LINKS_SUCCESS = 'GET_PDP_LINKS_SUCCESS';
const SET_LOCATION_MISMATCH_INITIAL_COUNTRY = 'SET_LOCATION_MISMATCH_INITIAL_COUNTRY';
const SET_LOCATION_MISMATCH_INITIAL_LANGUAGE = 'SET_LOCATION_MISMATCH_INITIAL_LANGUAGE';
export const setPageProperties = createAction(SET_PAGE_PROPERTIES);
export const setCurrentSku = createAction(SET_CURRENT_SKU);
export const getPDPLinksSuccess = createAction(GET_PDP_LINKS_SUCCESS);
export const setLocationMismatchInitialCountry = createAction(SET_LOCATION_MISMATCH_INITIAL_COUNTRY);
export const setLocationMismatchInitialLanguage = createAction(SET_LOCATION_MISMATCH_INITIAL_LANGUAGE);
